<template lang="html">
	<div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="ctn-toggle row">
				<div class="label">
					Etes-vous intéressé par des critères de durabilité ?
				</div>
				<custom-toggle :value="interestedBySustainability" @change="changeInterestedBySustainability($event)"/>
			</div>
			<div v-if="interestedBySustainability" class="ctn-tags row">
				<div class="tag" v-for="(tag, key) in durabilites" v-bind:key="key" @click="toggleTag(tag)" :class="{active: isActiveTag(tag), locked: isLocked(tag)}">
					{{ tag }}
				</div>
			</div>
			<div class="ctn-toggle row">
				<div class="label">
					Êtes-vous prêt à accepter des performances moindres en cas d'investissements ESG ?
				</div>
				<custom-toggle :value="acceptLowerPerformance" @change="changeAcceptLowerPerformance($event)"/>
			</div>
		</form>
	</div>
</template>

<script>
import CustomToggle from '@/common/components/Form/CustomToggle'
import { mapGetters } from 'vuex'

export default {
	name: 'Esg',
	components: {
		CustomToggle
	},
	data () {
		return {
			interestedBySustainability: false,
			acceptLowerPerformance: false,
			durabilite: [],
			durabilites: [
				'environnementaux',
				'sociaux',
				'gouvernance'
			]
		}
	},
	mounted() {
		if (this.estate && this.estate.esg) {
			this.interestedBySustainability = this.estate.esg.interestedBySustainability || false
			this.acceptLowerPerformance = this.estate.esg.acceptLowerPerformance || false
			this.durabilite = this.estate.esg.durabilite ? Array.from(this.estate.esg.durabilite) : []
		}
	},
	methods: {
		changeInterestedBySustainability (value) {
			this.interestedBySustainability = value
			if (!value) {
				this.durabilite = []
			}
		},
		changeAcceptLowerPerformance (value) {
			this.acceptLowerPerformance = value
		},
		validate () {
			return new Promise((resolve, reject) => {
				resolve(true)
			})
		},
		toggleTag (value) {
			if (value !== 'Aucun' || this.durabilite.length === 0) {
				if (this.durabilite.indexOf(value) === -1) {
					this.durabilite.push(value)
				} else {
					this.durabilite.splice(this.durabilite.indexOf(value), 1)
				}
			}
			if (this.durabilite.length > 1) {
				const key = this.durabilite.indexOf('Aucun')
				if (key !== -1) {
					this.durabilite.splice(key, 1)
				}
			}
		},
		isActiveTag (value) {
			return (this.durabilite.indexOf(value) !== -1)
		},
		isLocked (value) {
			if (value !== 'Aucun') return false
			return (this.durabilite.length > 0 && this.durabilite.indexOf(value) === -1)
		},
		save () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('storePatrimonial',
				{
					name: 'ESG',
					data: {
						interestedBySustainability: this.interestedBySustainability,
						acceptLowerPerformance: this.acceptLowerPerformance,
						durabilite: this.durabilite
					},
					fromStart: false
				}).then(() => {
					resolve()
				}).catch((error) => {
					reject(error)
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	},
	watch: {
		'estate.esg': {
			handler () {
				if (this.estate && this.estate.esg) {
					this.interestedBySustainability = this.estate.esg.interestedBySustainability || false
					this.acceptLowerPerformance = this.estate.esg.acceptLowerPerformance || false
					this.durabilite = this.estate.esg.durabilite ? Array.from(this.estate.esg.durabilite) : []
				}
			},
			deep: true
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/Esg.vue